import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import * as api from 'src/utils/api';
import authService from 'src/services/authService';
import * as actions from './actions';
import * as snackbarActions from '../Snackbar/actions';

function* signUp(action: any) {
  try {
    yield call(api.signUp, action.payload);
    authService.setEmail(action.payload.email);
    yield put(push('/verify-your-email'));
  } catch (e) {
    if (e.response.data.email) {
      action.formActions.setFormError(e.response.data.email[0]);
    }
  } finally {
    action.formActions();
  }
}

function* signIn(action: any) {
  try {
    // action.formActions.setSubmissionInFlight(true);
    const user = yield call(api.logInWithUsernamePassword, action.payload);
    authService.setSession(user.jwt.access);
    authService.removeEmail();
    yield put(actions.signUserIn(user));
  } catch (e) {
    if (e.response.data.verify) {
      authService.setEmail(action.payload.email);
      yield put(push('/verify-your-email'));
    } else if (e.response.data.error) {
      action.formActions.setFormError(e.response.data.error);
    } else if (e.response.data.detail) {
      action.formActions.setFormError(e.response.data.detail);
    } else {
      action.formActions.setFormError('Something went wrong');
    }
  } finally {
    action.formActions();
  }
}

function* getCurrentUser() {
  try {
    const user = yield call(api.getCurrentUser);
    yield put(actions.signUserIn(user));
  } catch {
    // doesn't matter if there's no current user
  } finally {
    yield put(actions.setUserLoading(false));
  }
}

function* signOut() {
  try {
    authService.logout();
    yield put(actions.signUserOut());
  } catch {
    // error banner
  }
}

function* sendEmailVerificationEmail(action: any) {
  try {
    const payload = { email: action.payload };
    yield call(api.sendEmailVerificationEmail, payload);
    yield put(snackbarActions.enqueueSnackbar({
      message: 'Verification email sent.',
      options: {
        variant: 'success',
      },
    }));
  } catch (e) {
    const message = e.response.data.user || 'Failed to send verification email';
    yield put(snackbarActions.enqueueSnackbar({
      message,
      options: {
        variant: 'error',
      },
    }));
  } finally {
    action.formActions();
  }
}

function* sendResetPasswordEmail(action: any) {
  try {
    const payload = { email: action.payload };
    yield call(api.sendResetPasswordEmail, payload);
    yield put(snackbarActions.enqueueSnackbar({
      message: 'Reset email sent',
      options: {
        variant: 'success',
      },
    }));
  } catch (e) {
    const message = e.response.data.user || 'Failed to send password reset email';
    yield put(snackbarActions.enqueueSnackbar({
      message,
      options: {
        variant: 'error',
      },
    }));
  } finally {
    action.formActions();
  }
}


function* confirmResetPassword(action: any) {
  try {
    yield call(api.confirmResetPassword, action.payload);
    yield put(snackbarActions.enqueueSnackbar({
      message: 'Password reset',
      options: {
        variant: 'success',
      },
    }));
    yield put(push('/login'));
  } catch (e) {
    const message = e.response.data.invalid_link || 'Failed to reset password';
    yield put(snackbarActions.enqueueSnackbar({
      message,
      options: {
        variant: 'error',
      },
    }));
  } finally {
    action.formActions();
  }
}

function* mySaga() {
  yield takeLatest(actions.SIGN_IN, signIn);
  yield takeLatest(actions.GET_CURRENT_USER, getCurrentUser);
  yield takeLatest(actions.SIGN_OUT, signOut);
  yield takeLatest(actions.SIGN_UP, signUp);
  yield takeLatest(actions.SEND_EMAIL_VERIFICATION_EMAIL, sendEmailVerificationEmail);
  yield takeLatest(actions.SEND_RESET_PASSWORD_EMAIL, sendResetPasswordEmail);
  yield takeLatest(actions.CONFIRM_RESET_PASSWORD, confirmResetPassword);
}

export default mySaga;
